import { useEffect } from 'react'

const Fkw = ({ url }) => {
  useEffect(() => {
    window.open(url, '_blank')
  }, [url])

  return null
}

export default Fkw
